import styled from 'styled-components';

export const StyledQuickFilterTabsContainer = styled.div`
  border-bottom: 1px solid #ddd;
  display: flex;
`;

export const StyledQuickFilterTab = styled.div`
  font-weight: ${({ selected }) => (selected ? 700 : 400)};
  font-size: 12px;
  padding: 0 24px 12px 24px;
  border-bottom: ${({ selected }) => (selected ? '2px solid #000' : 'none')};
  cursor: pointer;
`;
